/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import TreeTeamsDropdown from 'components/teams/TreeTeamsDropdown/TreeTeamsDropdown';
import Text from 'components/base/Text';
import * as TrackingService from 'common/services/tracking.service';
import Dropdown from 'components/base/Dropdown';
import {
  ALL_ACCOUNTS_TYPES_OPTIONS,
  TRACKING
} from 'common/constants/constants';
import Footer from './Footer';
import Header from './Header';
import usePermissionsData from './usePermissionsData';
import { CircularProgress } from '@material-ui/core';
import emptyTeams from 'images/emptyTeams.svg';
import { allTeams } from 'connected-components/TopBar/TopBar.service';
import RoleBasedModules from './RoleBasedModules';

const StyledDropdownWrapper = styled.div`
  padding-top: 0.7rem;
  .MuiInputBase-root {
    width: 25rem;
    height: 2rem;
  }
  .MuiSelect-select {
    width: 25rem !important;
  }
`;

const EmptyTeamsImg = styled.img`
  position: absolute;
  background-color: white;
  z-index: 100;
  top: 4.3rem;
  height: 3.5rem;
  width: 25rem;
  pointer-events: none;
`;

const StyledDiv = styled.div`
  height: 20rem;
`;

const Permissions = ({ isMultiple }) => {
  const {
    selectedAccounts,
    accountTypeId,
    setAccountTypeId,
    isAdmin,
    selectedTeamIds,
    onTeamDropdownChange,
    onSaveAccount,
    treeTeams,
    isLoading,
    isLoadingUpdate,
    onSaveBulkAccounts,
    allTeamsGroupId,
    isAllTeamsGroup,
    roleBasedModules
  } = usePermissionsData({ isMultiple });

  const Loading = () => (
    <Flex
      justify='start'
      height='15rem'
      pt='5rem'
      pl='3rem'
      data-testid='spinner'
    >
      <CircularProgress size='4rem' color='primary' />
    </Flex>
  );

  const PermissionsSection = () => (
    <StyledDiv>
      <Flex direction='column' pt='medium'>
        <Text pb='0.7rem' color='shuttleGray'>
          USER ROLE
        </Text>
        <StyledDropdownWrapper>
          <Dropdown
            options={ALL_ACCOUNTS_TYPES_OPTIONS}
            selectedValue={accountTypeId}
            onChange={setAccountTypeId}
            data-cy='edit-user-permissions-role-picker'
          />
        </StyledDropdownWrapper>
      </Flex>
      <Flex direction='column' pt='x-medium' pb='medium' position='relative'>
        <Text pb='0.7rem' color='shuttleGray'>
          USER TEAMS
        </Text>
        {!selectedTeamIds.length && <EmptyTeamsImg src={emptyTeams} alt='' />}
        <TreeTeamsDropdown
          isFilterTreeBySelectRoot={false}
          selectedTeamIds={
            isAdmin && !isAllTeamsGroup ? [allTeams.id] : selectedTeamIds
          }
          onChange={selectedTeams => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.SETTINGS,
              page_tab: TRACKING.PAGE_TABS.PERMISSIONS,
              click_type:
                TRACKING.CLICK.RBAC.SETTINGS.DROPDOWN.SELECT_USER_TEAMS_SCOPE
            });
            return onTeamDropdownChange(selectedTeams);
          }}
          disabledTeamIds={
            isAdmin
              ? treeTeams
                  .filter(({ id }) => id !== allTeamsGroupId)
                  .map(({ id }) => id)
              : []
          }
          isDisableChildrenOfSelectedParent
          multiple
          isAllowNoDefault
          isHideAllContributors={true}
          dataCyPrefix='user-permissions'
        />
      </Flex>
      <RoleBasedModules config={roleBasedModules} />
    </StyledDiv>
  );

  const content = isLoading ? <Loading /> : <PermissionsSection />;

  return (
    <Flex direction='column'>
      <Header selectedAccounts={selectedAccounts} />
      {content}
      <Footer
        onSave={isMultiple ? onSaveBulkAccounts : onSaveAccount}
        disableSave={isLoadingUpdate || !selectedTeamIds.length}
      />
    </Flex>
  );
};

export default Permissions;
